export { default } from "@vendors/CreativeTim/components/Card/CardBody.js";
